import { AccessRequestsApiDryRunCreateUserAccessRequestRequest, useAccessRequestsApi } from '@client-app-sdk';
import { useMutation } from '@tanstack/react-query';

export default function useDryRunCreateUserAccessRequest() {
  const api = useAccessRequestsApi();

  const { mutate: dryRunCreateUserAccessRequest, ...rest } = useMutation(
    async (payload: AccessRequestsApiDryRunCreateUserAccessRequestRequest) => {
      const res = await api.dryRunCreateUserAccessRequest(payload);
      return res;
    },
  );

  return {
    dryRunCreateUserAccessRequest,
    ...rest,
  };
}
